import localizationProvider from "../localization/localizationProvider";
import toLower from "lodash/toLower";
import { parsePhoneNumber } from "libphonenumber-js";
import type { InternalEnumNames } from "../services/localizationService";
import { unbreakableSpaces } from "./localizationUtils";
import type LicensePlate from "../entities/licensePlate";
import type Vehicle from "../entities/vehicleResponse";

export function translateGeneral(code: string, size?: number) {
  return localizationProvider.translateGeneral(code, size);
}

export function translateEnum(enumName: InternalEnumNames, value: any, size?: number) {
  return localizationProvider.translateEnum(enumName, value, size);
}

export function formatDate(date?: Date | null, options?: Intl.DateTimeFormatOptions) {
  options = options ? options : { month: "2-digit", day: "2-digit", year: "numeric" };
  return localizationProvider.formatDate(date, options).replace(/\. /g, ".").replace(/ /g, "\u00a0");
}

export function formatDateMonth(date?: Date | null, options?: Intl.DateTimeFormatOptions) {
  options = options ? options : { month: "2-digit", year: "numeric" };
  return localizationProvider.formatDate(date, options).replace(/\. /g, ".").replace(/ /g, "\u00a0");
}

export function formatDateFilename(date?: Date | null) {
  if (!date) {
    return "";
  }

  const m = date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  const d = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  return `${d}${m}${date.getFullYear().toString().substr(2)}`;
}

export function formatDateTime(date?: Date | null, options?: Intl.DateTimeFormatOptions) {
  options = options
    ? options
    : { month: "2-digit", day: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" };
  return localizationProvider.formatDateTime(date, options).replace(/\. /g, ".");
}

export function formatTime(date?: Date | null, options?: Intl.DateTimeFormatOptions) {
  return unbreakableSpaces(localizationProvider.formatTime(date, options));
}

export function formatNumber(num: number, options?: Intl.NumberFormatOptions) {
  return localizationProvider.formatNumber(num, options);
}

export function formatAmount(amount?: number, currency = "czk") {
  return amount !== undefined && amount !== null
    ? unbreakableSpaces(
        `${localizationProvider.formatNumber(amount)} ${localizationProvider.translateGeneral(toLower(currency))}`
      )
    : undefined;
}

export function formatLicensePlate(vehicle: Vehicle | LicensePlate) {
  return localizationProvider.formatLicensePlate(vehicle);
}

export function formatPhoneNumber(phoneNumber: string) {
  try {
    const parsed = parsePhoneNumber(phoneNumber);
    return parsed.formatInternational();
  } catch {
    return phoneNumber;
  }
}
